import { lazy } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route, Routes } from 'react-router-dom';

const AdministrationPage = lazy(() => import('../../Modules/Administration/AdministrationPage'));
const DashboardPageWrapper = lazy(() => import( '../../Modules/Dashboard/DashboardPageWrapper'));
const WorkspacePageWrapper = lazy(() => import( '../../Modules/Workspace/WorkspacePageWrapper'));

const AppRoutes = 
    createBrowserRouter(
        createRoutesFromElements(
        <Route key='root' path='/'>
            <Route key='workspace' index element={<WorkspacePageWrapper />}/>
            <Route key='workspace-by-id' path=':id' element={<WorkspacePageWrapper />} />
            <Route key='workspaces' path='workspaces' element={<DashboardPageWrapper/>} />
            <Route key='admin' path='administration' element={<AdministrationPage />}/>
        </Route>
    ));

export default AppRoutes;